import { Building2 } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function SupplierQualificationPage() {
  return (
    <PhaseStubPage
      title="Supplier qualification"
      phase={5}
      modules={[
        'Per-vendor qualification record (qualified / conditional / disqualified)',
        'Auto-computed scorecard from POs + GRs + NCRs',
        'Re-qualification reminders before expiry',
        'PO blocking when vendor status drops below threshold',
      ]}
      icon={Building2}
    />
  );
}
